import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, errorMessage } from "@/lib/api";
import { State, Failed } from "@/pages/Subscribe";

export default function BillingLink() {
  const [params] = useSearchParams();
  const [error, setError] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    api.post("/public/billing-portal", { token: params.get("token") || "" })
      .then(({ data }) => window.location.assign(data.url))
      .catch((e) => setError(errorMessage(e)));
  }, [params]);

  if (error) return <Failed message={error} />;
  return <State status="loading" title="Opening your billing page..." sub="Taking you to Stripe to update your card." />;
}
